import React from 'react'
import { withStyles } from 'material-ui/styles'
import { CircularProgress } from 'material-ui/Progress';

const styles = {
    root: {
      zIndex: 1,
      width: 'calc(100% - 7px)',
      height: '100%',
      position: 'absolute',
      top: 0,
      left: 0,
      // Remove grey highlight
      WebkitTapHighlightColor: 'transparent',
      willChange: 'opacity',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
    },
    invisible: {
      backgroundColor: 'transparent',
    },
    loading: {
        position: `absolute`,
        top: `50%`,
        left: `50%`,
        transform: `translate(-50%, -50%)`,
    },
    loadingColor: {
        stroke: 'white'
    }
  };


const Loading = (props) => {
    const isLoading = props.isLoading
    const containerClassName = isLoading ? props.classes.root : props.classes.invisible
    return (
        <div className={containerClassName}>
            {isLoading ? (
                <CircularProgress className={props.classes.loading}
                                  classes={{
                                      circle: props.classes.loadingColor
                                  }}
                                  size={64}
                                  thickness={4}
                                  color="secondary"/>
            ) : null}
        </div>
    )
}

export default withStyles(styles)(Loading)


// WEBPACK FOOTER //
// ./src/components/loading.js